import { FETCH_USER_PERMISSIONS_FAILURE, FETCH_USER_PERMISSIONS_REQUEST, FETCH_USER_PERMISSIONS_SUCCESS } from "../Actions/Actions";


const initialState = {
  isLoading: false,
  userPermissions: [],
  error: null,
};

const userPermissionsListReducer = (state = initialState,{type,payload}) => {
  switch (type) {
    case FETCH_USER_PERMISSIONS_REQUEST:
      return { ...state, isLoading: true, error: null  };
    case FETCH_USER_PERMISSIONS_SUCCESS:
      return { ...state, isLoading: false, userPermissions: payload};
    case FETCH_USER_PERMISSIONS_FAILURE:
      return { ...state, isLoading: false, error: payload };
    default:
      return state;
  }
};

export default userPermissionsListReducer;
